import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import WhatsAppIntentDialog from './WhatsAppIntentDialog';

// Scroll threshold for showing floating buttons
const SCROLL_THRESHOLD = 800;

/**
 * Shared Floating Action Buttons Component
 * Used across Home, Services, Pricing, Find a Tutor, and Become a Tutor pages
 * 
 * Features:
 * - Book Free Trial button (navigates to enquiry form)
 * - WhatsApp button (opens WhatsApp chat)
 * - Appears after scrolling past threshold
 * - Consistent styling across all pages
 */
const FloatingActionButtons = () => {
  const navigate = useNavigate();
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButtons(window.scrollY > SCROLL_THRESHOLD);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBooking = () => {
    const enquiryForm = document.getElementById('enquiry-form');
    if (enquiryForm) {
      // If on homepage with enquiry form, scroll to it
      enquiryForm.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Otherwise, navigate to the booking page
      navigate('/get-started');
    }
  };

  return (
    <>
      {/* Book Free Trial Button - Uses sticky-cta class from App.css */}
      {showButtons && (
        <div className="sticky-cta">
          <Button onClick={scrollToBooking} className="btn-gold shadow-2xl">
            <Calendar className="w-5 h-5" />
            Book Free Trial
          </Button>
        </div>
      )}

      {/* Floating WhatsApp Button — opens the intent picker so we can route
          the user into the correct conversation funnel. */}
      <WhatsAppIntentDialog source="floating-button">
        <button
          type="button"
          className="whatsapp-float"
          aria-label="Chat on WhatsApp"
          data-testid="floating-whatsapp-btn"
        >
          <MessageCircle className="w-7 h-7" />
        </button>
      </WhatsAppIntentDialog>
    </>
  );
};

export default FloatingActionButtons;
